exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".nav-link.embedded.menu span{font-size:.9rem;padding-left:0}.nav-link.menu.embedded.active span{color:#234dd0}.nav-link.menu.embedded:hover span,.nav-link.menu.embedded:hover i{color:#4976e8}.bg-embedded-nav-bar{background-color:#f6f6f7}.nav-link.menu.embedded span{color:#202223}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/postcss-loader/lib??ref--1-2!./node_modules/sass-loader/dist/cjs.js??ref--1-3!./src/common/layout/embeddednavbar.scss
// module id = 6365
// module chunks = 0